module.exports = __webpack_public_path__ + "static/img/101401.c0ecff11.png";